import { colors } from '@material-ui/core';

export const partners = [
  {
    name: 'Airbnb',
    logo: 'https://assets.maccarianagency.com/the-front/logos/airbnb.svg',
  },
  {
    name: 'Coinbase',
    logo: 'https://assets.maccarianagency.com/the-front/logos/coinbase.svg',
  },
  {
    name: 'Dribbble',
    logo: 'https://assets.maccarianagency.com/the-front/logos/dribbble.svg',
  },
  {
    name: 'Instagram',
    logo: 'https://assets.maccarianagency.com/the-front/logos/instagram.svg',
  },
  {
    name: 'Netflix',
    logo: 'https://assets.maccarianagency.com/the-front/logos/netflix.svg',
  },
  {
    name: 'Pinterest',
    logo: 'https://assets.maccarianagency.com/the-front/logos/pinterest.svg',
  },
];

export const jobCategories = [
  {
    iconColor: colors.blue,
    iconBg: colors.blue,
    icon: 'fas fa-pen-nib',
    title: 'Web Design',
  },
  {
    iconColor: colors.purple,
    iconBg: colors.purple,
    icon: 'fas fa-book-open',
    title: 'Business Analytics',
  },
  {
    iconColor: colors.amber,
    iconBg: colors.amber,
    icon: 'fas fa-camera-retro',
    title: 'Photography',
  },
  {
    iconColor: colors.indigo,
    iconBg: colors.indigo,
    icon: 'fas fa-video',
    title: 'Video Creating',
  },
  {
    iconColor: colors.pink,
    iconBg: colors.pink,
    icon: 'fas fa-heartbeat',
    title: 'Health & Fitness',
  },
  {
    iconColor: colors.green,
    iconBg: colors.green,
    icon: 'fas fa-bullhorn',
    title: 'Marketing',
  },
  {
    iconColor: colors.deepOrange,
    iconBg: colors.deepOrange,
    icon: 'fas fa-funnel-dollar',
    title: 'Finances & Sales',
  },
  {
    iconColor: colors.red,
    iconBg: colors.red,
    icon: 'fas fa-paint-brush',
    title: 'Graphic Design',
  },
];

export const jobs = [
  {
    color: colors.blue[500],
    title: 'web design',
    jobTitle: 'Web designer internship',
    type: 'Full time',
    location: 'Milan, Italy',
    date: '3 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    companyName: 'Slack',
  },
  {
    color: colors.purple[500],
    title: 'business analytics',
    jobTitle: 'Senior business analysts',
    type: 'Full time',
    location: 'Rome, Italy',
    date: 'Just now',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    companyName: 'Google Ads',
  },
  {
    color: colors.amber[500],
    title: 'photography',
    jobTitle: 'Mid-level photographer',
    type: 'Remote',
    location: 'Yerevan, Armenia',
    date: '1 week ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/atlassian.svg',
    companyName: 'Atlassian',
  },
  {
    color: colors.indigo[500],
    title: 'video creating',
    jobTitle: 'Senior video creator',
    type: 'Part time',
    location: 'Paris, France',
    date: '2 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/dropbox.svg',
    companyName: 'Dropbox',
  },
  {
    color: colors.pink[500],
    title: 'health & fitness',
    jobTitle: 'Expert fitness consultant',
    type: 'Remote',
    location: 'Yerevan, Armenia',
    date: '1 month ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    companyName: 'Google Ads',
  },
  {
    color: colors.green[500],
    title: 'marketing',
    jobTitle: 'Senior digital marketing specialist',
    type: 'Full time',
    location: 'Milan, Italy',
    date: '4 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-drive.svg',
    companyName: 'Google Drive',
  },
  {
    color: colors.deepOrange[500],
    title: 'finances & sales',
    jobTitle: 'Senior sales manager',
    type: 'Part Time',
    location: 'Paris, France',
    date: '5 days ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/mailchimp.svg',
    companyName: 'Mail Chimp',
  },
  {
    color: colors.red[500],
    title: 'graphic design',
    jobTitle: 'Junior graphic designer',
    type: 'Remote',
    location: 'Milan, Italy',
    date: '2 weeks ago',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    companyName: 'Slack',
  },
  {
    color: colors.purple[500],
    title: 'business analytics',
    jobTitle: 'Senior business analysts',
    type: 'Full time',
    location: 'Rome, Italy',
    date: 'Just now',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    companyName: 'Google Ads',
  },
];

export const companies = [
  {
    title: 'Photography',
    location: 'Yerevan, Armenia',
    jobs: '3 jobs',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/atlassian.svg',
    companyName: 'Atlassian',
    subtitle:
      'Keep your entire team in sync with development and easily manage tasks, goals, and deadlines.',
  },
  {
    title: 'Video Creating',
    location: 'Paris, France',
    jobs: '4 jobs',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/dropbox.svg',
    companyName: 'Dropbox',
    subtitle:
      'Sync any file store to Dropbox for automated sharing with people outside the company.',
  },
  {
    title: 'Health & Fitness',
    location: 'Yerevan, Armenia',
    jobs: '10 jobs',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-ad-manager.svg',
    companyName: 'Google Ads',
    subtitle:
      'Easily manage and edit any Adwords campaign inline to improve ROI with constant review.',
  },
  {
    title: 'Marketing',
    location: 'Milan, Italy',
    jobs: '3 jobs',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/google-drive.svg',
    companyName: 'Google Drive',
    subtitle:
      'Sync any file store to Google Drive for automated sharing with people outside the company.',
  },
  {
    title: 'Finances & Sales',
    location: 'Paris, France',
    jobs: '2 jobs',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/mailchimp.svg',
    companyName: 'Mail Chimp',
    subtitle:
      'Communicate important messages to your users through TheFront using Mailchimp as the delivery service.',
  },
  {
    title: 'Graphic Design',
    location: 'Milan, Italy',
    jobs: '8 jobs',
    companyLogo: 'https://assets.maccarianagency.com/the-front/logos/slack.svg',
    companyName: 'Slack',
    subtitle:
      "Sync your team's work and activity to share automatically in a channel with a simple plugin.",
  },
];

export const faq = [
  {
    id: 'faq-1',
    title: 'Flexible access to facilities.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    link: 'Check it out',
  },
  {
    id: 'faq-2',
    title: 'Snacks, drinks, coffee, and more.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    link: 'Check it out',
  },
  {
    id: 'faq-3',
    title: 'On site tech support.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    link: 'Check it out',
  },
  {
    id: 'faq-4',
    title: 'Flexible access to facilities.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    link: 'Check it out',
  },
  {
    id: 'faq-5',
    title: 'Snacks, drinks, coffee, and more.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    link: 'Check it out',
  },
  {
    id: 'faq-6',
    title: 'On site tech support.',
    subtitle: 'Our new key fobs make it so easy!',
    text:
      'Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat! Lorem ipsum dolor sit amet, consectetur adipisicing elit. Sunt rerum minima a possimus, amet perferendis, temporibus obcaecati pariatur. Reprehenderit magnam necessitatibus vel culpa provident quas nesciunt sunt aut cupiditate fugiat!',
    link: 'Check it out',
  },
];
